<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ L.localize('Members_ChangeGroup') }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <div class="form js-form">
          <submenu />
          <div class="options-list">
            <div class="options-list__item" v-for="group in groups">
              <div class="options-list__content">
                <h2 class="options-list__title">{{ group.name }}</h2>
              </div>
              <div class="options-list__control" :data-acc="acc.generate('toggle', group.name)">
                <input
                  class="options-list__checkbox"
                  type="checkbox"
                  :data-acc="acc.generate('input', group.name)"
                  v-model="currentGroups"
                  :value="group.id"
                  :id="group.id"
                  @click="toggle(group.id)" />
                <label class="options-list__toggle" :for="group.id"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>

  </article>
</template>

<script>
import Submenu from 'components/views/members/Submenu'
import { mapGetters } from 'vuex'
import L from 'services/Localization'
import notifications from 'mixins/notifications'
import acc from 'services/Acceptance'

export default {
  name: 'member-change-group',
  data() {
    return {
      L: L,
      acc: acc
    }
  },
  components: { Submenu },
  mixins: [notifications],
  beforeCreate() {
    this.$store.dispatch('getMember', this.$route.params.id)
    this.$store.dispatch('getAllGroups')
  },
  computed: {
    ...mapGetters({
      groups: 'allGroups',
      pagination: 'allGroupsPagination',
      member: 'activeMember'
    }),
    currentGroups() {
      if (this.member && this.member.groups != null) {
        return this.member.groups.map(group => { return group.id })
      }
      return []
    }
  },
  methods: {
    toggle(groupId) {
      let groups = this.currentGroups
      if (_.includes(groups, groupId)) {
        groups.splice(groups.indexOf(groupId), 1)
      } else {
        groups.push(groupId)
      }
      this.$store.dispatch('setMemberGroups', { memberId: this.member.id, groupIds: groups })
        .then(() => {
          this.showNotification({
            title: L.localize('Label_SuccessEdit'),
            message: L.localize('Label_Success')
          })
        })
    }
  }
}
</script>

<style lang='scss'>

</style>



// WEBPACK FOOTER //
// MemberChangeGroup.vue?024ca930